import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type RoleType = 'teacher' | 'student' | 'hr' | 'student-demo' | 'dev' | 'admin';



 type InitialStateType = {
     roleType: RoleType | undefined;
};

const initialState: InitialStateType = {
    roleType: undefined,
};

const slice = createSlice({
    name: 'role',
    initialState,
    reducers: {
        setRoleType(state, action: PayloadAction<RoleType>) {
            state.roleType = action.payload;
        },
    },
});

export const roleReducers = slice.reducer;
export const { setRoleType } = slice.actions;
